/// <reference path="../../Common/Helpers/GridEditorBase.ts" />

namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class ApprovalReceiptDetailsEditor extends _Ext.ItemGridEditor<ReceiptDetailsRow> {
        protected getColumnsKey() { return "Retail.ReceiptDetails"; }
        protected getDialogType() { return ReceiptDetailsDialog; }
        protected getLocalTextPrefix() { return ReceiptDetailsRow.localTextPrefix; }
        exchangerate: number;
        rateid: string;
        constructor(container: JQuery) {
            super(container);

            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as any).CalculateTotals();
                }
            })

        }
        protected getButtons() {
            let buttons = super.getButtons();

            var addbutton = buttons.filter(x => x.cssClass == "add-button")[0];
            addbutton.hotkey = 'alt+r';
            addbutton.title = 'Add Receipt';

 
            buttons.push({
                title: "Exchange",
                cssClass: "add-button",
                hotkey: "alt+e",
                onClick: () => {
                    var customerid = parseInt((this.parentDialog as POSSalesDialog).form.POSCustomerId.value)
                    // **** Validate Party before Item Selection ****
                    if (customerid == 0 || customerid == null) {
                        Q.notifyWarning("Please select Customer to proceed");
                        return;

                    } else {

                        var grid = ExchangeSelectGrid;
                        var filters: _Ext.SelectGridFilters = {
                            CustomerId: customerid,
                        }
                        var pickerDialog = new _Ext.GridItemPickerDialog({

                            gridType: grid, multiple: true, title: 'Select Exchange Note', GridFilters: filters

                        });
                    }

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.RefNo == t.RefNo) });
                        var self = this;
                        var details = [];

                        selectedItems2.forEach(function (value: POSReturnRow) {
                            var code = OMS.PaymentModeRow.getLookup().itemById[15].Code;
                            var Receipt: ReceiptDetailsRow = {
                                LedgerId: value.PartyId,
                                Mode: 15,
                                LedgerName: code,
                                Amount: value.GrossAmount,
                                RefNo: value.VoucherNo, 
                                RefTransId: value.TransId,
                            };
                            details.push(Receipt);

                        });

                        for (let Detail of details) {
                            Detail[this.getIdProperty()] = "`" + this.nextId++;
                            var x = Detail;
                            if (this.validateEntity(Detail, Detail.Id)) {
                                this.view.addItem(Detail);
                            }
                        }

                    }

                    pickerDialog.dialogOpen();
                }
            });

            

            return buttons;
        }
        
        validateEntity(row, id) { 
            var sameProduct = Q.tryFirst(this.view.getItems(), x => x.LedgerId === row.LedgerId);
            if (sameProduct && this.id(sameProduct) !== id) {
                Q.alert('This Ledger is already in order details!');
                return false;
            }

            row.LedgerName = OMS.AccountLedgerRow.getLookup().itemById[row.LedgerId].LedgerName;
            //row.LineTotal = (row.Quantity || 0) * (row.UnitPrice || 0) - (row.Discount || 0);
            return true;
        }

        

    }
}